(function () {
'use strict';

const BASE_URL = /liulishuo/i.test(location.href)
  ? 'https://apitelis.llsapp.com'
  : 'https://telis.llsstaging.com';

function queryString(search = location.search) {
  const query = {};
  if (search) {
    const params = search.substring(1).split('&');
    params.forEach(item => {
      const kv = item.split('=');
      if (kv[1]) {
        query[kv[0]] = decodeURIComponent(kv[1]);
      }
    });
  }
  return query;
}



function isWeixin() {
  return /micromessenger/.test(window.navigator.userAgent.toLowerCase());
}

function CountDown(config) {
  this.day = config.day;
  this.hour = config.hour;
  this.minute = config.minute;
  this.startTime = new Date().getTime();
  this.endTime = new Date(config.dateline).getTime();
  this._time = { day: 0, hour: 0, minute: 0 };
}

CountDown.prototype = {
  init() {
    setInterval(() => {
      this.render();
    }, 1000);
  },
  getCountdown() {
    this.startTime = new Date().getTime();
    this.countdown = Math.max(0, this.endTime - this.startTime) / 1000;
    const day = Math.floor(this.countdown / (24 * 3600));
    const hour = Math.floor(this.countdown % (24 * 3600) / 3600);
    const minute = Math.ceil(this.countdown % (24 * 3600) % 3600 / 60);
    return { day, hour, minute };
  },
  render() {
    this.time = this.getCountdown();
    if (this._time.day !== this.time.day) {
      this._time.day = this.time.day;
      this.day.textContent = this.time.day;
    }
    if (this._time.hour !== this.time.hour) {
      this._time.hour = this.time.hour;
      this.hour.textContent = this.time.hour;
    }
    if (this._time.minute !== this.time.minute) {
      this._time.minute = this.time.minute;
      this.minute.textContent = this.time.minute;
    }
  },
};

function WxShare(params = {}) {
  this.debug = !!params.debug;
}

WxShare.prototype = {
  fetch(url, success) {
    const request = new XMLHttpRequest();
    request.open('GET', `${BASE_URL}/wxconfig?url=${encodeURIComponent(url)}`, true);
    request.onload = function() {
      if (request.status >= 200 && request.status < 400) {
        const data = JSON.parse(request.responseText);
        success(data);
      }
    };
    request.send();
  },
  register(url, apiList = []) {
    this.fetch(url, (data) => {
      window.wx.config({
        debug: this.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appid, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.noncestr, // 必填，生成签名的随机串
        signature: data.signature,// 必填，签名，见附录1
        jsApiList: apiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
    });
  },
  ready(config) {
    window.wx.ready(() => {
      if ('shareTimeline' in config) {
        window.wx.onMenuShareTimeline(config.shareTimeline);
      }
      if ('shareAppMessage' in config) {
        window.wx.onMenuShareAppMessage(config.shareAppMessage);
      }
      if ('shareQQ' in config) {
        window.wx.onMenuShareQQ(config.shareQQ);
      }
      if ('shareQZone' in config) {
        window.wx.onMenuShareQZone(config.shareQZone);
      }
      if ('shareWeibo' in config) {
        window.wx.onMenuShareWeibo(config.shareWeibo);
      }
    });
  }
};

const DEFAULT_PLATFORM = 'web';
const DEFAULT_APP_NAME = 'lls';
const APP_MARKETING_VERSION = '1.0';
const TRACK_URL = 'https://flm3.llsapp.com/data_collect';

function queryString$1(search) {
  const query = {};
  if (search) {
    const params = search.substring(1).split('&');
    params.forEach(item => {
      const kv = item.split('=');
      if (kv[1]) {
        query[kv[0]] = decodeURIComponent(kv[1]);
      }
    });
  }
  return query;
}

const query = queryString$1(location.search);

function Track(config) {
  this.app_name = config.app_name || DEFAULT_APP_NAME;
  this.platform = config.platform || DEFAULT_PLATFORM;
  this.app_marketing_version = config.version || APP_MARKETING_VERSION;
}

Track.prototype = {
  makeRandomIdStr(strLen) {
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let text = '';
    for(let i = 0; i < strLen; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  },
  getSessionId() {
    let sessionId = window.sessionStorage.getItem('sessionId');
    if(!sessionId) {
      sessionId = Math.floor(Date.now() / 1000) + '.' + this.makeRandomIdStr(6);
      window.sessionStorage.setItem('sessionId', sessionId);
    }
    return sessionId;
  },
  getTempUserId() {
    return 'tmp' + this.getSessionId();
  },
  getChannelId() {
    let channelId = query.channel || window.sessionStorage.getItem('channelId');
    if(channelId) {
      window.sessionStorage.setItem('channelId', channelId);
    }
    return channelId;
  },
  buildTrackPackage(trackData) {
    const commonData = {
      platform: this.platform,
      session_id: this.getSessionId(),
      app_marketing_version: this.app_marketing_version
    };
    trackData.time = this._formatedTimeNow();
    trackData.channel = this.getChannelId() || '';
    return {
      user_id: this.getTempUserId(),
      app_name: this.app_name,
      common_data: commonData,
      batch_data: [{
        event_type: 22,
        payload: trackData
      }]
    };
  },
  _zeroFill(num, targetLength) {
    const absNum = Math.abs(num).toString();
    const zerosToFill = targetLength - absNum.length;
    return Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNum;
  },
  _formatedTimeNow() {
    const t = new Date();
    const year = t.getFullYear();
    const month = this._zeroFill(t.getMonth() + 1, 2);
    const day = this._zeroFill(t.getDate(), 2);
    const hour = this._zeroFill(t.getHours(), 2);
    const minutes = this._zeroFill(t.getMinutes(), 2);
    const seconds = this._zeroFill(t.getSeconds(), 2);
    return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`;
  },
  normalizeTrackpayload(params) {
    const normalizedPayload = {};
    for (let key in params) {
      normalizedPayload[this._dasherize(key)] = params[key];
    }
    return normalizedPayload;
  },
  _dasherize(str) {
    return /[A-Z]/g.test(str) ? str.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase() : str;
  },
  xhr(options) {
    const request = new XMLHttpRequest();
    request.open(options.type, options.url, true);
    request.setRequestHeader('Content-Type', options.contentType);
    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        if (options.success) {
          options.success();
        }
      } else {
        if (options.error) {
          options.error();
        }
      }
    };
    request.send(options.data);
  },
  send(params, success) {
    const trackData = this.normalizeTrackpayload(params);
    const trackPackage = this.buildTrackPackage(trackData);
    this.xhr({
      url: TRACK_URL,
      data: JSON.stringify(trackPackage),
      type: 'POST',
      contentType: 'application/json',
      success : success
    });
  },
  sendPageTrack(params = {}, success) {
    params.action = 'page_view';
    this.send(params, success);
  },
  sendActionTrack(params, success) {
    this.send(params, success);
  },
  sendTrack(type = 'page', actionOrPageName, success) {
    if (type === 'page') {
      this.sendPageTrack({
        pageName: actionOrPageName
      }, success);
    } else {
      this.sendActionTrack({
        action: actionOrPageName
      }, success);
    }
  }
};

const BARGAIN_MAP = {
  50: '<h5>帮砍<strong>50</strong>元！</h5>阁下功力超凡<br>令人敬佩！',
  40: '<h5>帮砍<strong>40</strong>元！</h5>少侠武艺精湛<br>佩服佩服！',
  30: '<h5>帮砍<strong>30</strong>元！</h5>看你身强体壮<br>原来只是稀松平常。',
  20: '<h5>帮砍<strong>20</strong>元！</h5>原以为深藏不露<br>却是个绣花枕头',
  10: '<h5>帮砍<strong>10</strong>元！</h5>你今天没吃饭吗？'
};

const BARGAIN_FINISH_OWNER = '<h5>福袋降临！</h5>快去找小雅妹: yslls002 领取吧！';

const ENCOURAGE_MAP = [
  ['革命才刚开始，发力吧少年！<br>限发起1次、帮砍1次', '考验友谊的时候到了！<br>限发起1次、帮砍1次'],
  ['奋勇砍价，所向披靡！<br>限发起1次、帮砍1次', '成功的道路永不言弃，继续前进！<br>限发起1次、帮砍1次'],
  ['再努把力就成功了！<br>限发起1次、帮砍1次', '暮然回首，还差一步！<br>限发起1次、帮砍1次'],
  ['距离成功只有一步之遥！<br>限发起1次、帮砍1次', '胜利就在眼前，莫要功亏一篑！<br>限发起1次、帮砍1次'],
];
const params = queryString(location.search);
const token = params.token;
let user_id = '';
let pageType = 'inviter';

const wxShare = new WxShare();
const wxShareRegister = ({ title, desc, link, imgUrl }) => {
  wxShare.ready({
    shareTimeline: {
      title: `${title}，${desc}`,
      link,
      imgUrl
    },
    shareAppMessage: {
      title,
      desc,
      link,
      imgUrl
    }
  });
};

const track = new Track({
  app_name: 'telis',
  platform: 'web',
  app_marketing_version: '2.0'
});

function fetchBargainInfo(callback) {
  $.ajax({
    url: BASE_URL + '/events/bargain',
    headers: {
      Accept: 'application/vnd.liulishuo.telis-v1+json',
      Authorization: 'Bearer ' + token,
    },
    dataType: 'json',
    success(resp) {
      callback(resp);
    },
  });
}

function fetchBargainHistory(id, callback) {
  $.ajax({
    url: BASE_URL + '/events/bargain/' + id + '/history',
    headers: {
      Accept: 'application/vnd.liulishuo.telis-v1+json',
      Authorization: 'Bearer ' + token,
    },
    dataType: 'json',
    success(resp) {
      callback(resp);
    },
    error() {
      callback();
    }
  });
}

function createBargain(id, success, error = () => {}) {
  $.ajax({
    url: BASE_URL + '/events/bargain/' + id + '/history',
    type: 'POST',
    headers: {
      Accept: 'application/vnd.liulishuo.telis-v1+json',
      Authorization: 'Bearer ' + token,
    },
    dataType: 'json',
    success(resp) {
      success(resp);
    },
    error() {
      error();
    },
  });
}

function App(config) {
  this.data = {
    id: config.user_id,
    expired: config.expired,
    nick: '',
    avatar: '',
    price: 180,
    history: [],
  };
  this.$default = $('.default');
  this.$information = $('.information');
  this.$status = $('.status');
  this.$ranking = $('.ranking');
  this.$result = $('.result');
  this.$share = $('.share');
  this.$shareTip = $('.share-tip');
  this.$join = $('.join');
  this.$buy = $('.buy');
}

App.prototype = {
  init(data, bargain) {
    if (data) {
      this.data.nick = data.nick;
      this.data.avatar = data.avatar;
      this.data.history = data.history;
      if (bargain) {
        let joiner = false;
        this.data.history.forEach(item => {
          if (item.bargainer_nick === bargain.bargainer_nick && item.bargainer_avatar === bargain.bargainer_avatar) {
            joiner = true;
          }
        });
        if (!joiner) {
          this.data.history.push(bargain);
        }
        this.initBargainPage(data, bargain, joiner);
      } else {
        if (this.data.price === 0) {
          this.updateResult({
            disc: BARGAIN_FINISH_OWNER
          });
          this.showResult(true);
        }
        this.initFinishedPage(data);
      }
    }
    this.initCountDown(this.data.expired);
    this.listen(this.data.expired);
  },
  listen(expiredDate) {
    const expired = new Date(expiredDate).getTime() - new Date().getTime() <= 0;
    $('.buy, .join, .bargain').on('click', (event) => {
      if (expired) {
        if (event.stopImmediatePropagation) {
          event.stopImmediatePropagation();
        }
        alert('活动已结束');
      }
    });
    this.$default.find('.bargain').on('click', () => {
      track.sendActionTrack({
        pageName: 'telis_bargain',
        category: 'login',
        action: 'telis_bargain_host_bargain'
      });
      createBargain(user_id, (bargain) => {
        this.data.history.push(bargain);
        this.updateResult({
          price: bargain.bargained_value,
          disc: `<h5>成功砍价<strong>${bargain.bargained_value}<strong>元</h5>少侠好功力<br>帮砍找兄弟！`,
        });
        this.updateStatus({
          name: bargain.bargainer_nick,
          price: this.data.price - bargain.bargained_value,
          count: this.data.history.length + 1,
          text: '恭喜您成功砍价' + bargain.bargained_value + '元！找兄弟继续帮你砍吧~',
        });
        this.updateRanking(this.data.history);
        this.$share.text('邀请好友帮我砍价').next().hide();
        this.showResult();
        this.showFinishedPage();
      });
    });
    this.$result.on('click', () => {
      this.showFinishedPage();
      this.hideResult();
    });
    this.$share.on('click', () => {
      track.sendActionTrack({
        pageName: 'telis_bargain',
        category: 'login',
        action: pageType === 'inviter' ? 'telis_bargain_friend_bargain' : 'telis_bargain_host_invite'
      });
      this.$shareTip.fadeIn(300);
    });
    this.$shareTip.on('click', () => {
      this.$shareTip.fadeOut(300);
    });
    this.$join.on('click', () => {
      track.sendActionTrack({
        pageName: 'telis_bargain',
        category: 'login',
        action: 'telis_bargain_invite_bargain'
      });
      setTimeout(() => {
        location.href = location.origin + location.pathname + '?token=' + token;
        history.replaceState({}, '', '');
      }, 50);
    });
    this.$buy.on('click', () => {
      track.sendActionTrack({
        pageName: 'telis_bargain',
        category: 'login',
        action: 'telis_bargain_buy'
      });
      setTimeout(() => {
        location.href = 'http://hybrid.liulishuo.com/lls-acts/yasi.html';
      }, 50);
    });
  },
  showResult(done = false) {
    this.$result.toggleClass('done', done);
    this.$result.fadeIn(300);
    window.setTimeout(() => {
      this.hideResult();
    }, 3000);
  },
  hideResult() {
    this.$result.fadeOut(300);
  },
  showFinishedPage() {
    this.$default.hide();
    this.$status.show();
    this.$information.hide();
    this.$ranking.show();
  },
  initFinishedPage(data) {
    let price = this.data.price;
    data.history.forEach(item => {
      price -= item.bargained_value;
    });
    this.data.price = price <= 0 ? 0 : price;
    let text = this._getEncourage();
    if (this.data.price === 0) {
      text = '恭喜！下载后加微信：yslls002 领福袋哦！';
      this.$status.find('.inner').addClass('finished');
      this.$share.hide().next().hide();
      this.$buy.show();
    } else {
      this.$share.text('邀请好友帮我砍价').next().hide();
    }
    this.updateStatus({
      name: this.data.nick,
      price: this.data.price,
      count: this.data.history.length,
      text: text,
    });
    this.updateRanking(this.data.history);
    this.showFinishedPage();
  },
  initBargainPage(data, bargain, joiner) {
    if (!joiner) {
      this.updateResult({
        price: bargain.bargained_value,
        disc: BARGAIN_MAP[bargain.bargained_value],
      });
      this.showResult();
    }
    let price = this.data.price;
    data.history.forEach(item => {
      price -= item.bargained_value;
    });
    this.data.price = price <= 0 ? 0 : price;
    let text = this._getEncourage();
    if (this.data.price === 0) {
      text = data.nick + '已获得免费专属福利！你也来试试吧！';
      this.$status.find('.inner').addClass('finished');
      this.$share.hide();
      this.$join.addClass('red');
    }
    this.updateStatus({
      name: bargain.nick || data.nick,
      price: this.data.price,
      count: this.data.history.length,
      text: text,
    });
    this.updateRanking(this.data.history);
    this.showFinishedPage();
  },
  _getEncourage() {
    if (this.data.history.length <= 2) {
      return this._randomArray(ENCOURAGE_MAP[0])[0];
    } else if (this.data.history.length <= 4) {
      return this._randomArray(ENCOURAGE_MAP[1])[0];
    } else if (this.data.history.length <= 6) {
      return this._randomArray(ENCOURAGE_MAP[2])[0];
    } else if (this.data.history.length <= 9) {
      return this._randomArray(ENCOURAGE_MAP[3])[0];
    }
  },
  _randomArray(array) {
    return array.sort(() => Math.random() - 0.5);
  },
  statusTpl(data) {
    let information = '';
    if (data.price === 0) {
      information = `<div class="current">
                      <p>${this.getLastBargainDate()}</p>
                      <p class="strong">完成砍价！</p>
                    </div>`;
    } else {
      information = `<div class="current">
                      <p>现价：<strong>${data.price}</strong> 元</p>
                      <p>最多再砍<span> ${9 - data.count} </span>次到底价！</p>
                    </div>`;
    }
    return `<div class="content">
              <div class="user"><span class="truncate">${data.name}</span></div>
              ${information}
            </div>
            <p class="tip">${data.text}</p>`;
  },
  updateStatus(data) {
    this.$status.find('.inner').html(this.statusTpl(data));
  },
  rankingTpl(data) {
    const list = [];
    data.forEach(item => {
      list.push(`<li>
                  <div class="avatar">
                    <img src="${this._http2https(item.bargainer_avatar)}">
                  </div>
                  <div class="content">
                    <div class="user">${item.bargainer_nick}</div>
                    <div class="info">${item.cheer}</div>
                  </div>
                </li>`);
    });
    return list.join('\n');
  },
  updateRanking(data) {
    this.$ranking.find('ol').html(this.rankingTpl(data));
  },
  resultTpl(data) {
    return `<p>${data.disc}</p>`;
  },
  updateResult(data) {
    this.$result.find('.content').html(this.resultTpl(data));
  },
  getLastBargainDate() {
    const lastBargain = this.data.history[this.data.history.length - 1];
    return lastBargain.bargained_at.substring(0, 16).replace('T', ' ');
  },
  initCountDown(expired) {
    const $countdown = document.getElementById('countdown');
    const countdown = new CountDown({
      day: $countdown.querySelector('.day'),
      hour: $countdown.querySelector('.hour'),
      minute: $countdown.querySelector('.minute'),
      dateline: expired,
    });
    countdown.init();
  },
  _parseDateISO8601(expired) {
    return expired.split('T')[0];
  },
  _http2https(link) {
    return link.replace('http://', 'https://');
  }
};

if (isWeixin()) {
  fetchBargainInfo((info) => {
    user_id = info.user_id.toString();
    if (!params.id) {
      location.href = location.href + (location.search.length > 0 ? '&' : '?') + 'id=' + user_id;
    }
    const app = new App({
      user_id: user_id,
      expired: info.expired_at,
    });
    const registerUrl = location.origin + location.pathname + location.search;
    wxShare.register(registerUrl, ['onMenuShareTimeline', 'onMenuShareAppMessage']);
    wxShareRegister({
      title: '雅思流利说 | 模考福袋0元抢',
      desc: '首款自带反馈buff的雅思口语库，等你来练！',
      link: location.origin + location.pathname + '?id=' + (/id\=/.test(location.search) ? params.id : user_id),
      imgUrl: 'https://cdn.llscdn.com/fe-static/telis/tmp/ielts-IAvjeohA.jpg',
      success: () => {
        track.sendActionTrack({
          pageName: 'telis_bargain',
          category: 'login',
          action: 'telis_bargain_share',
          who: pageType === 'inviter' ? 'inviter' : 'host'
        });
      },
    });
    fetchBargainHistory(params.id, (data) => {
      if (data && data.history) {
        if (!params.id || user_id === params.id) {
          pageType = 'host';
          app.init(data);
        } else {
          createBargain(params.id, (bargain) => {
            app.init(data, bargain);
          }, () => {
            app.init(data, data.history[data.history.length - 1]);
          });
        }
      } else {
        app.init();
      }
    });
  });
} else {
  $('.wx-tip').show();
}

track.sendPageTrack({
  pageName: 'telis_bargain',
  category: 'login'
});

}());
